import {
    ClientFunction,
    FunctionName,
    FunctionNamespace,
    FunctionQualifiedName
} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/ClientFunction';
import {SheetType} from '@mintdata/mint-kit/api/functions/SheetAPI';
import {Type} from '@mintdata/mint-kit/api/types/Type';

export class ClientFunctionUtil
{

    public static toCIQualifiedName(namespace:FunctionNamespace, name:FunctionName):FunctionQualifiedName
    {
        return `${namespace}.${name}`.toUpperCase();
    }

    public static hasMatchingSignature(cf:ClientFunction,
                                       argTypes:(Type | SheetType)[],
                                       returnType:Type | SheetType = null):boolean
    {
        if( !argTypes )
            return false;

        /*
                let i = 0;
                for( let arg of cf.args )
                {
                    // First argument to functions that use sheetAPI is always
                    // ctx:ISheetContext
                    if( i === 0 && cf.isUsingSheetAPI )
                    {
                        i = 1;
                        continue;
                    }

                    const funcArgType = arg.type;

                    if( !funcArgType.isSheetType )
                    {
                        const type = funcArgType.type;
                        const callSiteArgType = argTypes[i];

                        const isEmpty = Type.Empty.isEqualTo(callSiteArgType);
                        const isError = Type.Error.isEqualTo(callSiteArgType);

                        if( !isEmpty && !isError && !type.isEqualTo(callSiteArgType))
                            return false;
                    }

                    i++;
                }

                if( returnType )
                {
                    const returns = cf.returns;

                    if( !returns )
                        return false;

                    const retType = returns.type;

                    if( retType.isSheetType )
                        return true;

                    if( !retType.type.isEqualTo(returnType) )
                        return false;
                }
        */

        return true;
    }
}
